import * as React from 'react'
import Svg from '../Svg'
export const SvgCheckmark = (props: React.SVGProps<SVGSVGElement>) => (
    <Svg
        width="100pt"
        height="100pt"
        viewBox="0 0 100 100"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        {...props}
    >
        <path d="M76.875 22.75c-.09.086-3.129 3.004-7 6.688S61 37.874 56 42.626s-9.996 9.496-13.875 13.188c-1.367 1.3-1.555 1.476-2.563 2.437L22.375 43.407 13.25 54.001l22 19 4.906 4.25 4.593-4.594c.09-.09 3.13-3.004 7-6.687s8.875-8.438 13.875-13.188 9.997-9.496 13.876-13.188 6.335-6.024 7.25-6.938z" />
    </Svg>
)
SvgCheckmark.isIcon = true
export default SvgCheckmark
